// Shared weather sections (landing, /advisories, future standalone weather screens). Hindi inferred, needs translator.
export const en = {
  "WEATHER_SECTION.ARIA_LABEL": "Current weather",
  "FORECAST_SECTION.TITLE": "Next 3 days forecast",
  "FORECAST_SECTION.DATE": "Date : {{date}}",
  "FORECAST_SECTION.EMPTY": "Forecast is not available right now.",
  "FORECAST_SECTION.ERROR": "Unable to load the forecast.",
  "FORECAST_SECTION.RETRY": "Retry",
  "WEATHER_METRIC.RAIN": "Rain",
  "WEATHER_METRIC.HUMIDITY": "Humidity",
  "WEATHER_METRIC.WIND_SPEED": "Wind Speed",
  "WEATHER_METRIC.DIRECTION": "Direction",
  "WEATHER_METRIC.RAIN_VALUE": "{{value}} mm",
  "WEATHER_METRIC.HUMIDITY_VALUE": "{{value}}%",
  "WEATHER_METRIC.WIND_SPEED_VALUE": "{{value}}km/hr",
  "WIND_DIRECTION.N": "North",
  "WIND_DIRECTION.NE": "Northeast",
  "WIND_DIRECTION.E": "East",
  "WIND_DIRECTION.SE": "Southeast",
  "WIND_DIRECTION.S": "South",
  "WIND_DIRECTION.SW": "Southwest",
  "WIND_DIRECTION.W": "West",
  "WIND_DIRECTION.NW": "Northwest",
  "AQI_SECTION.TITLE": "Air Quality Index",
  "AQI_SECTION.INDEX_LABEL": "AQI Index",
  "AQI_SECTION.GAUGE_LABEL": "Air quality index {{value}}, {{band}}",
  "AQI_SECTION.NO_VALUE": "Air quality index not available",
  "AQI_SECTION.ERROR": "Unable to load air quality.",
  "AQI_SECTION.RETRY": "Retry",
  "AQI_SECTION.TIP_PENDING": "Tip: guidance for today's air quality will appear here.",
  "AQI_SECTION.SOURCE": "Source : Central Pollution Control Board, Govt of India",
  "AQI_BAND.GOOD": "Good",
  "AQI_BAND.SATISFACTORY": "Satisfactory",
  "AQI_BAND.MODERATE": "Moderate",
  "AQI_BAND.POOR": "Poor",
  "AQI_BAND.VERY_POOR": "Very Poor",
  "AQI_BAND.SEVERE": "Severe",
  "AGROMET_THIS_WEEK.TITLE": "This Week's Advisory",
  "AGROMET_THIS_WEEK.EMPTY": "No advisories for this week.",
  "WEATHER_HOME.EYEBROW": "— WEATHER",
  "WEATHER_HOME.TITLE": "Forecast",
  "WEATHER_HOME.EXPLORE_MORE": "Explore more",
  "WEATHER_HOME.UNAVAILABLE_TITLE": "Weather data unavailable",
  "WEATHER_HOME.UNAVAILABLE_MESSAGE":
    "We're unable to fetch weather information right now. This could be due to a temporary issue with the IMD data source.",
  "WEATHER_HOME.TODAY": "Today",
  "WEATHER_HOME.DEFAULT_DISTRICT": "Patna",
  "WEATHER_HOME.STATE": "Bihar",
  "WEATHER_HOME.HIGH_LOW": "High {{high}}° · Low {{low}}°",
  "WEATHER_HOME.DAY_SUN": "Sun",
  "WEATHER_HOME.DAY_MON": "Mon",
  "WEATHER_HOME.DAY_TUE": "Tue",
  "WEATHER_HOME.DAY_WED": "Wed",
  "WEATHER_HOME.DAY_THU": "Thu",
  "WEATHER_HOME.DAY_FRI": "Fri",
  "WEATHER_HOME.DAY_SAT": "Sat",
  "WEATHER_HOME.HUMIDITY_ICON_ALT": "Humidity icon",
  "WEATHER_HOME.HUMIDITY_LABEL": "Humidity",
  "WEATHER_HOME.WIND_DIRECTION_ICON_ALT": "Wind direction icon",
  "WEATHER_HOME.WIND_DIRECTION_LABEL": "Wind Direction",
  "WEATHER_HOME.WIND_SPEED_ICON_ALT": "Wind speed icon",
  "WEATHER_HOME.WIND_SPEED_LABEL": "Wind Speed",
  "WEATHER_HOME.WIND_SPEED_UNIT": "km/h",
  "WEATHER_HOME.RAINFALL_ICON_ALT": "Rainfall icon",
  "WEATHER_HOME.RAINFALL_LABEL": "Rainfall",
  "WEATHER_HOME.RAIN_UNIT": "mm",
  "WEATHER_HOME.ADVISORY_ARIA_LABEL": "Weather advisory",
  "WEATHER_HOME.SOURCE_PREFIX": "Source: ",
  "WEATHER_HOME.SOURCE_IMD": "India Meteorological Department",
  "WEATHER_HOME.SOURCE_MAUSAM_SEVA_KENDRA": "Mausam Seva Kendra",
  "WEATHER_ADVISORY.LEVEL_1": "Advisory — Stay informed",
  "WEATHER_ADVISORY.LEVEL_2": "Yellow Alert — Be Aware",
  "WEATHER_ADVISORY.LEVEL_3": "Orange Alert — Be Prepared",
  "WEATHER_BANNER.HIGH": "High",
  "WEATHER_BANNER.LOW": "Low",
  "WEATHER_BANNER.VIEW_DETAILS": "View details",
  "WEATHER_ADVISORY.LEVEL_4": "Red Alert — Immediate action required",
};

export const hi = {
  "WEATHER_SECTION.ARIA_LABEL": "वर्तमान मौसम",
  "FORECAST_SECTION.TITLE": "अगले 3 दिनों का पूर्वानुमान",
  "FORECAST_SECTION.DATE": "दिनांक : {{date}}",
  "FORECAST_SECTION.EMPTY": "पूर्वानुमान अभी उपलब्ध नहीं है।",
  "FORECAST_SECTION.ERROR": "पूर्वानुमान लोड नहीं हो सका।",
  "FORECAST_SECTION.RETRY": "पुनः प्रयास करें",
  "WEATHER_METRIC.RAIN": "वर्षा",
  "WEATHER_METRIC.HUMIDITY": "आर्द्रता",
  "WEATHER_METRIC.WIND_SPEED": "हवा की गति",
  "WEATHER_METRIC.DIRECTION": "दिशा",
  "WEATHER_METRIC.RAIN_VALUE": "{{value}} मिमी",
  "WEATHER_METRIC.HUMIDITY_VALUE": "{{value}}%",
  "WEATHER_METRIC.WIND_SPEED_VALUE": "{{value}} किमी/घंटा",
  "WIND_DIRECTION.N": "उत्तर",
  "WIND_DIRECTION.NE": "उत्तर-पूर्व",
  "WIND_DIRECTION.E": "पूर्व",
  "WIND_DIRECTION.SE": "दक्षिण-पूर्व",
  "WIND_DIRECTION.S": "दक्षिण",
  "WIND_DIRECTION.SW": "दक्षिण-पश्चिम",
  "WIND_DIRECTION.W": "पश्चिम",
  "WIND_DIRECTION.NW": "उत्तर-पश्चिम",
  "AQI_SECTION.TITLE": "वायु गुणवत्ता सूचकांक",
  "AQI_SECTION.INDEX_LABEL": "AQI सूचकांक",
  "AQI_SECTION.GAUGE_LABEL": "वायु गुणवत्ता सूचकांक {{value}}, {{band}}",
  "AQI_SECTION.NO_VALUE": "वायु गुणवत्ता सूचकांक उपलब्ध नहीं है",
  "AQI_SECTION.ERROR": "वायु गुणवत्ता लोड नहीं हो सकी।",
  "AQI_SECTION.RETRY": "पुनः प्रयास करें",
  "AQI_SECTION.TIP_PENDING": "सुझाव: आज की वायु गुणवत्ता के लिए मार्गदर्शन यहाँ दिखाई देगा।",
  "AQI_SECTION.SOURCE": "स्रोत: केंद्रीय प्रदूषण नियंत्रण बोर्ड, भारत सरकार",
  "AQI_BAND.GOOD": "अच्छा",
  "AQI_BAND.SATISFACTORY": "संतोषजनक",
  "AQI_BAND.MODERATE": "मध्यम",
  "AQI_BAND.POOR": "खराब",
  "AQI_BAND.VERY_POOR": "बहुत खराब",
  "AQI_BAND.SEVERE": "गंभीर",
  "AGROMET_THIS_WEEK.TITLE": "इस सप्ताह की सलाह",
  "AGROMET_THIS_WEEK.EMPTY": "इस सप्ताह के लिए कोई सलाह नहीं है।",
  "WEATHER_HOME.EYEBROW": "— मौसम",
  "WEATHER_HOME.TITLE": "मौसम पूर्वानुमान",
  "WEATHER_HOME.EXPLORE_MORE": "और ज्यादा खोजें",
  "WEATHER_HOME.UNAVAILABLE_TITLE": "मौसम डेटा अनुपलब्ध",
  "WEATHER_HOME.UNAVAILABLE_MESSAGE":
    "हम अभी मौसम की जानकारी प्राप्त नहीं कर पा रहे हैं। यह IMD डेटा स्रोत में अस्थायी समस्या के कारण हो सकता है।",
  "WEATHER_HOME.TODAY": "आज",
  "WEATHER_HOME.DEFAULT_DISTRICT": "पटना",
  "WEATHER_HOME.STATE": "बिहार",
  "WEATHER_HOME.HIGH_LOW": "अधिकतम {{high}}° · न्यूनतम {{low}}°",
  "WEATHER_HOME.DAY_SUN": "रविवार",
  "WEATHER_HOME.DAY_MON": "सोमवार",
  "WEATHER_HOME.DAY_TUE": "मंगलवार",
  "WEATHER_HOME.DAY_WED": "बुधवार",
  "WEATHER_HOME.DAY_THU": "गुरुवार",
  "WEATHER_HOME.DAY_FRI": "शुक्रवार",
  "WEATHER_HOME.DAY_SAT": "शनिवार",
  "WEATHER_HOME.HUMIDITY_ICON_ALT": "आर्द्रता आइकन",
  "WEATHER_HOME.HUMIDITY_LABEL": "नमी",
  "WEATHER_HOME.WIND_DIRECTION_ICON_ALT": "हवा की दिशा आइकन",
  "WEATHER_HOME.WIND_DIRECTION_LABEL": "हवा की दिशा",
  "WEATHER_HOME.WIND_SPEED_ICON_ALT": "हवा की गति आइकन",
  "WEATHER_HOME.WIND_SPEED_LABEL": "हवा की गति",
  "WEATHER_HOME.WIND_SPEED_UNIT": "किमी/घंटा",
  "WEATHER_HOME.RAINFALL_ICON_ALT": "वर्षा आइकन",
  "WEATHER_HOME.RAINFALL_LABEL": "वर्षा",
  "WEATHER_HOME.RAIN_UNIT": "मिमी",
  "WEATHER_HOME.ADVISORY_ARIA_LABEL": "मौसम सलाह",
  "WEATHER_HOME.SOURCE_PREFIX": "स्रोत: ",
  "WEATHER_HOME.SOURCE_IMD": "भारत मौसम विज्ञान विभाग",
  "WEATHER_HOME.SOURCE_MAUSAM_SEVA_KENDRA": "मौसम सेवा केंद्र",
  "WEATHER_ADVISORY.LEVEL_1": "मौसम सलाह — अपडेट रहें",
  "WEATHER_ADVISORY.LEVEL_2": "पीला अलर्ट — सतर्क रहें",
  "WEATHER_ADVISORY.LEVEL_3": "नारंगी अलर्ट — तैयार रहें",
  "WEATHER_BANNER.HIGH": "अधिकतम",
  "WEATHER_BANNER.LOW": "न्यूनतम",
  "WEATHER_BANNER.VIEW_DETAILS": "विवरण देखें",
  "WEATHER_ADVISORY.LEVEL_4": "लाल अलर्ट — तत्काल कार्रवाई आवश्यक",
};
